import React, { useEffect, useState } from 'react';
import { FaEye, FaFileMedical } from 'react-icons/fa';

function MedicalRecord({ patientData }) {
  const [files, setFiles] = useState([]);

  // Load existing files from patientData
  useEffect(() => {
    if (patientData?.filedetails) {
      const existingFiles = patientData.filedetails.map((file) => ({
        name: file.filename || 'Existing File',
        url: file.fileurl,
      }));
      setFiles(existingFiles);
    }
  }, [patientData]);

  return (
    <div className="flex flex-col gap-6">
      <div className="space-y-2">
        <h3 className="text-2xl font-semibold text-gray-800">Medical Files</h3>
        <h4 className="text-lg text-gray-600">EHR Data</h4>
        <p className="text-sm italic text-gray-500">
          These files contain extracted data used for analysis.
        </p>
      </div>
      {files.length > 0 && (
        <div className="grid grid-cols-6 gap-4">
          {files.map((file, index) => (
            <div
              key={index}
              className="relative flex flex-col items-center rounded-lg border bg-white p-2 shadow-sm"
            >
              <div className="py-2">
                <FaFileMedical size={24} className="text-gray-600" />
              </div>
              <h6 className="m-0 text-xs italic">
                {file.name.split('_')[0].length > 10
                  ? file.name.split('_')[0].slice(0, 2) + '...'
                  : file.name.split('_')[0]}
              </h6>
              <div className="absolute right-1 top-1">
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-900 transition hover:text-blue-700"
                >
                  <FaEye size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MedicalRecord;
